import React from 'react';
import PropTypes from 'prop-types';

import loadingSvg from 'Assets/images/loading-bubbles-96x96.svg';

const Loading = ({visible, centered, className, inline, style, position}) => {
  if (!visible) return null;

  return (
    <div
      className={`mhd--loading ${inline ? 'inline-load' : ''} ${
        centered ? 'centered' : ''
      } ${className}`}
      data-testid="loading"
      style={{position: 'relative', ...style}}
    >
      <img alt="Loading..." src={loadingSvg} style={{position: position}} />
    </div>
  );
};

Loading.defaultProps = {
  centered: false,
  className: '',
  inline: false,
  position: 'inherit',
  style: {},
  visible: true,
};

Loading.propTypes = {
  centered: PropTypes.bool,
  visible: PropTypes.bool,
  className: PropTypes.string,
  inline: PropTypes.bool,
  position: PropTypes.string,
  style: PropTypes.shape({}),
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Common/Structure/Loading.js